<template>
  <v-col class="py-0">
  <SocialTextFieldTitle v-if="showTitle" :title="title" :icon="icon" :isSvg="true"  :can-disabled="canDisabled" :is-disabled="isDisabled" @change="changeValue"/>
    <v-slide-y-transition v-if="canDisabled ? isDisabled : true">
  <v-text-field outlined dense
                :rules="requiredRules"
                validate-on-blur
                placeholder="yourhandle"
                :label="label" @input="onChange($event)"
                :value="value"
                :hint="`e.g. ${urlPrefix}pappyon`" class="pb-0">
    <template v-slot:prepend-inner>
      <div class="ml-1 mr-n1 mt-1" v-if="!value.includes('http')">{{ urlPrefix }}</div>
    </template>
  </v-text-field>
    </v-slide-y-transition>
  </v-col>
</template>
<script>
import SocialTextFieldTitle from "@/components/MultiConnect/Sponsors/SocialTextFieldTitle.vue"

export default {
  name: 'SocialTextFields',
  components: {SocialTextFieldTitle},
  data() {
    return {
      isDisabled: false,
    }
  },
  created() {
    if(this.value != "" && this.value != null && this.value!=undefined) {
      this.changeValue(true);
    }
  },
  methods: {
    onChange(value) {
      this.$emit('input', value)
    },
    changeValue(value) {
      this.isDisabled = value
      if(!this.isDisabled){
        this.$emit('input', "")
      }
    }
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    requiredRules: {
      type: Array,
      required: true,
    },
    urlPrefix: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    canDisabled: {
      type: Boolean,
      default: false,
    },
    showTitle: {
      type: Boolean,
      default: true,
    }
  }
}
</script>